"use strict";
if (!Reflect.getMetadata) {
    console.warn("reflect-metadata is not enabled. class-tansformer and class-validator features of @polyratings/shared will result in an error");
    Reflect.getMetadata = () => null;
}
//# sourceMappingURL=reflect-metadata-warning.js.map